/**
 * Function to get the avatar and the name of the participants of the conversations
 * @param {*} chats
 * @param {*} subscribers
 * @returns
 */
export const addChatParticipantInfo = (chats = [], subscribers = []) => {
  const updatedChat = chats.map((chat) => {
    const subscriber = subscribers.find(
      (sub) => String(sub._id) === String(chat.chatWithId)
    );
    if (subscriber) {
      return {
        ...chat,
        chatWithName: subscriber.name,
        avatar: subscriber.avatar,
      };
    }
    return chat;
  });

  return updatedChat;
};

/**
 * Sort conversations ascending o descending
 * @param {*} conversations
 * @param {*} sortOrder
 * @returns
 */
export const sortConversationsByName = (conversations, sortOrder = "asc") => {
  // Remove special characters
  const normalizeString = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const sortArray = (array) => {
    return array.sort((a, b) => {
      const nameA = normalizeString(
        a.chatWithName || a.subject || ""
      ).toLowerCase();
      const nameB = normalizeString(
        b.chatWithName || b.subject || ""
      ).toLowerCase();

      if (nameA < nameB) return sortOrder === "asc" ? -1 : 1;
      if (nameA > nameB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  };

  return {
    ...conversations,
    readChannels: sortArray(conversations.readChannels),
    readDirects: sortArray(conversations.readDirects),
    unreadChats: sortArray(conversations.unreadChats),
  };
};

/**
 * Sort conversations by most recent
 * @param {*} conversations
 * @returns
 */
export const sortByMostRecent = (conversations) => {
  const sortArray = (array) => {
    return array.sort((a, b) => {
      const timeA = a.lastMessageAt || 0;
      const timeB = b.lastMessageAt || 0;
      return timeB - timeA;
    });
  };

  return {
    ...conversations,
    readChannels: sortArray(conversations.readChannels),
    readDirects: sortArray(conversations.readDirects),
    unreadChats: sortArray(conversations.unreadChats),
  };
};

/**
 * Get the conversations filtered by name
 * @param {*} conversations
 */
export const getFilteredConversations = (filterValue, conversations) => {
  const filteredConversations = filterValue
    ? conversations.filter(
        (conv) =>
          conv.subject?.toLowerCase().startsWith(filterValue.toLowerCase()) ||
          conv.chatWithName?.toLowerCase().startsWith(filterValue.toLowerCase())
      )
    : conversations;
  return filteredConversations;
};

export const modifyConversation = async (api, body) => {
  await api(`modify-conversation`, {
    method: "PUT",
    body,
  });
};

export const getCommunityChatConversations = async (api, userId) => {
  const res = await api("community-chat-conversations", {
    query: { userId },
  });
  const resJSON = await res.json();
  const data = resJSON?.chats || {
    readChannels: [],
    readDirects: [],
    unreadChats: [],
    lastConversationId: null,
  };
  return data;
};

export const getCommunityConversation = async (api, conversationId) => {
  const res = await api("community-channel", {
    query: { conversationId },
  });
  const resJSON = await res.json();
  const data = resJSON?.conversation || null;
  return data;
};

export const getGuestsUsersInfo = async (api, guestIds) => {
  const res = await api("guests-users-conversation-info", {
    query: { guests: JSON.stringify(guestIds) },
  });
  const resJSON = await res.json();
  return resJSON?.guests || [];
};

export const getTeamConversation = async (api, teamId, ownerId) => {
  const query = {
    coachId: String(ownerId),
    userId: String(ownerId),
    teamId,
  };

  const res = await api("get-teams-chat", { query });

  const resJSON = await res.json();

  const data = resJSON.conversation || null;

  return data;
};

export const getConversationLabel = (
  isPush = "false",
  isPress = "false",
  isPerform = "false",
  isPull = "false",
  teamId = null
) => {
  if (teamId) return "TEAMS";
  const active = [];
  if (isPush === "true") active.push("PUSH");
  if (isPress === "true") active.push("PRESS");
  if (isPerform === "true") active.push("PERFORM");
  if (isPull === "true") active.push("PULL");
  if (active.length === 0) return null;
  if (active.length >= 3) return "ALL";
  if (active.length === 2) return active.join("+");
  return active[0];
};

export const getConversationLabelColor = (label) => {
  if (label === "PUSH") return { color: "#4E81F2", background: "#4E81F21A" };
  if (label === "TEAMS") return { color: "#00AFE4", background: "#00AFE41A" };
  if (label === "PRESS") return { color: "#C15FFF", background: "#C15FFF1A" };
  if (label === "PERFORM") return { color: "#E97C2C", background: "#E97C2C1A" };
  if (label === "PULL") return { color: "#FF6B6B", background: "#FF6B6B1A" };
  return { color: "#2DD540", background: "#2DD5401A" };
};
